<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 26 26"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10.425 18.8953C15.103 18.8953 18.8953 15.103 18.8953 10.425C18.8953 5.74696 15.103 1.95468 10.425 1.95468C5.74696 1.95468 1.95468 5.74696 1.95468 10.425C1.95468 15.103 5.74696 18.8953 10.425 18.8953ZM10.425 20.8499C4.66742 20.8499 0 16.1825 0 10.425C0 4.66742 4.66742 0 10.425 0C16.1825 0 20.8499 4.66742 20.8499 10.425C20.8499 16.1825 16.1825 20.8499 10.425 20.8499ZM19.1678 21.0107C18.6574 20.5003 18.6527 19.6776 19.1651 19.1651C19.674 18.6562 20.4901 18.6472 21.0107 19.1678L25.6126 23.7697C26.123 24.2801 26.1277 25.1028 25.6153 25.6153C25.1064 26.1242 24.2903 26.1332 23.7697 25.6126L19.1678 21.0107Z" :fill="fill"/>
  </svg>

</template>

<script>

export default {
  name: 'Search',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
  },
};

</script>
